( function ( _s ) {
	_s( document ).ready( () => {
		const _header = _s( '#app > header.banner' );
		const _logo = _s( '.navbar-brand' );

		const setBodyTopPadding = () => {
			const headerHeight = _header.outerHeight();
			const logoHeight = _logo.length ? _logo.outerHeight() : 0;

			// Do NOT add the admin-bar height here. WordPress already offsets the whole
			// document for the bar with `html { margin-top: 32px !important }` (46px on
			// small screens), and our header is `position: absolute` inside that shifted
			// document — so its bottom edge already clears the bar. Adding the bar again
			// double-counted it and left a gap exactly the bar's height between the
			// header and the first section, visible only when logged in.
			let height = headerHeight;

			if ( logoHeight > height ) {
				height = logoHeight;
			}

			window.setRootProperty( '--body-top-padding', height + 'px' );

			_s( window ).trigger( 'fr:set-body-top-padding-updated' );
		};

		_s( window ).on( 'fr:set-body-top-padding', () => {
			setBodyTopPadding();
		} );

		setBodyTopPadding();
	} );
} )( window._s );
